<template>
  <div class="flex flex-column" style="background-color: #fff; flex: 1 1 0%;">
    <div
      class="flex flex-fill flex-column"
      style="
        justify-content: center;
        align-items: center;
        padding: 20px;
        line-height: 2em;
      "
    >
      <div style="margin-top: 40px;">
        <span>创建收集表请移驾至收集表PC端</span>
      </div>
      <div>
        <span>收集表地址：{{ url }}</span>
      </div>
      <div style="padding: 12px;">
        <van-button
          size="small"
          type="default"
          v-clipboard:copy="url"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
          style="margin-left: 15px;"
          class="btn--text"
          >复制链接</van-button
        >
      </div>
    </div>
    <div
      class="flex flex-row flex-auto"
      style="justify-content: center; align-items: center; padding: 20px;"
    >
      <!-- <van-button type="info" block @click="goBack">返回</van-button> -->
    </div>
  </div>
</template>
<script>
import { Button, Notify, Toast } from "vant";
export default {
  name: "questionnaire-add-mobile",
  components: {
    [Button.name]: Button,
  },
  props: {
    url: { type: String },
  },
  methods: {
    onCopySuccess() {
      Notify({
        message: "链接已成功复制到剪切板",
        type: "success",
      });
    },
    onCopyError(e) {
      console.error(e);
      Toast("复制失败");
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>
